import { Stack } from '@mui/material';
import useModal from '../../hooks/custom/useModal';
import { onRefresh } from '../../utils/refreshPage';
import Spinner from '../Spinner';
import ModalErrorFetch from '../UI/ModalErrorFetch';
import { ComponentsSection, DivisionSectionFrom } from '../XcalaComponents/DivisionSectionFrom';
import { InputFiled } from './InputFiled';
import { InputSelectFiled } from './InputSelectFiled';
import { useSelector } from 'react-redux';

export const FormDatas = ({
  contactField,
  handleChangeContactFields,
  isEditContactData,
  errorPhone,

  errorRegisterUserDataRegistration,
  loadingRegisterUserDataRegistration,
}) => {
  const { isShowing, toggle } = useModal();

  const { user } = useSelector(state => state.auth);

  const userData = {
    fantasyName: user['custom:fantasyName'],
    rutSociety: user['custom:dni'],
    representativeName: `${user.name} ${user['custom:paternal-surname']}`,
    representativeRut: user['custom:representativeRut'],
    contactPhone: user.phone_number,
    email: user.email,
    adress: user.address,
  };

  if (errorRegisterUserDataRegistration) {
    return (
      <ModalErrorFetch
        message='Oh! parece que esto no funcionó bien...'
        error={errorRegisterUserDataRegistration}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }
  if (loadingRegisterUserDataRegistration) {
    return (
      <ComponentsSection>
        <Spinner />
      </ComponentsSection>
    );
  }

  return (
    <ComponentsSection>
      <Stack sx={{ width: '100%', flexDirection: 'column', boxSizing: 'border-box' }}>
        <DivisionSectionFrom textTitle='Datos de la Sociedad' show={false} />

        <Stack flexDirection='row' gap={3} flexWrap={'wrap'}>
          <InputFiled nameFiled='Nombre Fantasía' info={userData.fantasyName} />
          <InputFiled nameFiled='Rut Sociedad' info={userData.rutSociety} />

          <InputFiled nameFiled='Dirección de la sociedad' info={userData.adress} />
        </Stack>
        <Stack sx={{ marginTop: '16px' }}>
          <DivisionSectionFrom textTitle='Datos del Apoderado' show={false} />

          <Stack flexDirection='row' gap={3} flexWrap={'wrap'}>
            <InputFiled nameFiled='Nombre Apoderado' info={userData.representativeName} />
            <InputFiled nameFiled='Rut Apoderado' info={userData.representativeRut} />
          </Stack>
        </Stack>

        <Stack sx={{ marginTop: '16px' }}>
          <DivisionSectionFrom textTitle='Datos de Contacto' show={false} />

          <Stack flexDirection='row' gap={3} flexWrap={'wrap'}>
            <InputFiled nameFiled='email' info={userData.email} />
            <InputFiled nameFiled='Telefono' info={userData.contactPhone} />
          </Stack>
        </Stack>
      </Stack>
    </ComponentsSection>
  );
};
